// data.js
export const ZonesAndStates = {
  
  NorthCentral: ["Benue", "Kogi", "Kwara", "Nasarawa", "Niger", "Plateau"],
  NorthEast: ["Adamawa", "Bauchi", "Borno", "Gombe", "Taraba", "Yobe"],
  NorthWest: [
    "Kaduna",
    "Kano",
    "Katsina",
    "Kebbi",
    "Jigawa",
    "Sokoto",
    "Zamfara",
  ],

  SouthEast: ["Abia", "Anambra", "Enugu", "Ebonyi", "Imo"],
  SouthSouth: ["Akwa Ibom", "Bayelsa", "Cross River", "Delta", "Edo", "Rivers"],
  SouthWest: ["Ondo", "Osun", "Oyo", "Ekiti", "Lagos", "Ogun"],
};
